
import store from './store.js'

export default {
  store,
  computed: {
    alerts() {
      return this.$store.state.alerts
    }
  },
  methods: {
    close(index) {
      this.$store.dispatch('close', index)
    }
  }
}
